import { API, graphqlOperation } from "aws-amplify";
import { listInterviewerAnnounceByInterviewIdSortBySortIndex } from "graphql/queries";
import {
  InterviewerAnnounce,
  ListInterviewerAnnounceByInterviewIdSortBySortIndexQuery,
} from "types/graphqlapi";

/**
 * 同一実査のアナウンスリストを取得
 * @param interviewId
 * @returns
 */
export const fetchInterviewerAnnounceByInterviewIdQuery = async (
  interview_id: string
) => {
  const result = (await API.graphql(
    graphqlOperation(listInterviewerAnnounceByInterviewIdSortBySortIndex, {
      interview_id,
      limit: 10000,
    })
  )) as {
    data: ListInterviewerAnnounceByInterviewIdSortBySortIndexQuery;
  };

  const list = result.data?.listInterviewerAnnounceByInterviewIdSortBySortIndex
    ?.items as InterviewerAnnounce[];

  return list;
};
